/**
 * Glitch intensity (0–11) for 404 GlitchWord effects.
 * Stored in localStorage; creators adjust via Settings → Glitch dial modal.
 */

export const GLITCH_STORAGE_KEY = "luster_glitch_intensity"
export const GLITCH_CHANGE_EVENT = "luster_glitch_intensity_change"

const MIN = 0
const MAX = 11
const DEFAULT = 3.25

function clamp(value: number): number {
  return Math.max(MIN, Math.min(MAX, value))
}

export function getGlitchIntensity(): number {
  if (typeof window === "undefined") return DEFAULT
  const raw = localStorage.getItem(GLITCH_STORAGE_KEY)
  if (raw == null) return DEFAULT
  const n = parseFloat(raw)
  return Number.isFinite(n) ? clamp(n) : DEFAULT
}

export function setGlitchIntensity(value: number): void {
  const v = clamp(value)
  localStorage.setItem(GLITCH_STORAGE_KEY, String(v))
  window.dispatchEvent(new CustomEvent(GLITCH_CHANGE_EVENT, { detail: v }))
}

export const GLITCH_INTENSITY_DEFAULT = DEFAULT
export const GLITCH_INTENSITY_MIN = MIN
export const GLITCH_INTENSITY_MAX = MAX
